import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ assetInventoryCategoryId = '', ...params }) => {
  return await dponetAPI.get(
    `/asset_inventory_categories/${assetInventoryCategoryId}`,
    {
      params,
    },
  )
}

export default {
  get,
}
